export const PROCESS_ENV = {
    AMPLITUDE_API_KEY: process.env.REACT_APP_AMPLITUDE_API_KEY || "",
    API_SYNC_URL: process.env.REACT_APP_API_SYNC,
    API_URL: process.env.REACT_APP_API_URL,
    API_VERSION_HEADER: `${process.env.npm_package_version}-${process.env.CI_COMMIT}`,
    CI_BUILD_TIME: process.env.CI_BUILD_TIME,
    CI_COMMIT: process.env.CI_COMMIT,
    DEPLOY_ENVIRONMENT: process.env.DEPLOY_ENVIRONMENT,
    FINWAY_ADMIN_EMAIL: process.env.REACT_APP_FINWAY_ADMIN_EMAIL,
    GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY || "",
    INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_NEW_APP_ID as string | undefined,
    INTERCOM_TEST_APP_ID: process.env.REACT_APP_INTERCOM_TEST_APP_ID as string | undefined,
    IS_USING_CHRISTMAS_THEME: process.env.REACT_APP_IS_USING_CHRISTMAS_THEME,
    IS_DEMO: process.env.REACT_APP_DEMO === "true",
    IS_LOCAL: process.env.DEPLOY_ENVIRONMENT === "localhost",
    IS_INTERCOM_ENABLED: process.env.REACT_APP_INTERCOM_ENABLED === "true",
    IS_HISTORY_OF_ALL_CHANGE_ENABLED: ["gobd", "localhost", "bugfixing"].includes(process.env.DEPLOY_ENVIRONMENT!),
    MAPBOX_ACCESS_TOKEN: process.env.MAPBOX_ACCESS_TOKEN,
    NODE_ENV: process.env.NODE_ENV,
    NPM_PACKAGE_VERSION: process.env.npm_package_version,
    REACT_APP_SHOW_INTERNAL_VERSION: process.env.REACT_APP_SHOW_INTERNAL_VERSION === "true",
    SENTRY_OPTION_DSN_URL: process.env.SENTRY_OPTION_DSN_URL,
    SENTRY_REPLAY_SESSION_SAMPLE_RATE: Number(process.env.SENTRY_REPLAY_SESSION_SAMPLE_RATE || "0"),
    SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || "0"),
    SENTRY_TRACING_SAMPLE_RATE: Number(process.env.SENTRY_TRACING_SAMPLE_RATE || "0.1"),
    STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY ?? "",
    WEAVR_UX_KEY: process.env.REACT_APP_WEAVR_UX_KEY as string | undefined,
    WEAVR_UX_SCRIPT_URL: process.env.REACT_WEAVR_UX_SCRIPT_URL,
}
